import { render, staticRenderFns } from "./MaterialBulkControls.vue?vue&type=template&id=117fac28"
import script from "./MaterialBulkControls.vue?vue&type=script&lang=js"
export * from "./MaterialBulkControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports